export default __webpack_public_path__ + "static/media/CaylaSneaker.108f3fea.jpg";